import angular from 'angular';
import apiClients from '../Components/ApiClients/apiClients.component';

export default angular
    .module('app.integrations.apiClients', [])
    .component("apiClients", apiClients)
    .name;